/**
 * [#e03fdbc2] Клиентский код публичных страниц. Отдельно от кабинета, чтобы лендинг и статьи
 * не загружали код кабинета и словари. Подхватывает готовый HTML из scripts/prerender.mjs.
 */
import { createSSRApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import PublicApp from './PublicApp.vue';
import { getConsent, startMetrikaAfterLoad, trackPage } from './pages/landing/metrika';
import { publicRoutes } from './publicRoutes';
import { DEFAULT_PUBLIC_LOCALE, isPublicLocale, splitLocale } from './seo/site';

const router = createRouter({
  history: createWebHistory(),
  routes: publicRoutes,
  scrollBehavior(to, _from, saved) {
    if (saved) return saved;
    if (to.hash) return { el: to.hash, top: 104, behavior: 'smooth' };
    return { top: 0 };
  },
});

router.afterEach(async (to, from) => {
  if (from.matched.length === 0) return;
  const locale = isPublicLocale(to.params.locale) ? to.params.locale : DEFAULT_PUBLIC_LOCALE;
  const { pageHead } = await import('./seo/head');
  document.title = pageHead(splitLocale(to.path).path, locale).title;
  trackPage(location.href, location.origin + from.fullPath);
});

const app = createSSRApp(PublicApp);
app.use(router);
void router.isReady().then(() => {
  app.mount('#app');
  if (getConsent() !== 'necessary') startMetrikaAfterLoad();
});
